import { PERMISSION_APP_ACCESS } from 'app-support/permissions/Permissions'
import { Switch } from 'react-router-dom'
import TroubleShootContainer from 'app-support/troubleshoot/components/Container'
import DefaultRevenueContainer from 'app-support/troubleshoot/accountancyDefaults/components/DefaultRevenueContainer'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import AccountancySoftwareContainer from './accountancyFilter/components/AccountancySoftwareContainer'
import { accountancyErrorList, accountancyRoute, accountancySoftwareRoute, defaultRevenueRoute } from 'routes/routeNames'
import AccountancyErrorList from './ErrorListContainer/components/AccountancyErrorList'

const TroubleshootRoutes = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_APP_ACCESS} exact path={accountancyRoute} component={TroubleShootContainer} />
    <PermissionRoute permission={PERMISSION_APP_ACCESS} path={defaultRevenueRoute} component={DefaultRevenueContainer} />
    <PermissionRoute permission={PERMISSION_APP_ACCESS} path={accountancySoftwareRoute} component={AccountancySoftwareContainer} />
    <PermissionRoute permission={PERMISSION_APP_ACCESS} path={accountancyErrorList} component={AccountancyErrorList} />
  </Switch>
)

export default TroubleshootRoutes
